export default __webpack_public_path__ + "static/media/jyo.a3c12f6b.jpg";